import { take, fork, put } from 'redux-saga/effects'
import { handleRequest } from './requests'

import { STATE_KEYS } from 'state/requests'

import {
    validateIsEmailExist,
    ValidateIsEmailPayloads,
    RegisterActions,
    ValidateIsEmailResponse,
    SignUpPayloads,
    signUp,
    SendInvitePayloads,
    sendInvite,
    SignUpDetailsPayloads,
    signUpDetails,
    inviteTeamMembers,
    InviteTeamMembersPayloads,
} from 'services/api/register'
import { saveAuthErrors, resetAuthErrors, ErrorCodes } from 'state/error/authErrors'

export function* handleVerifyEmailRequest(payload: ValidateIsEmailPayloads) {
    yield handleRequest<ValidateIsEmailPayloads, ValidateIsEmailResponse>({
        stateKey: STATE_KEYS.VerifyEmail,
        payload,
        ApiHandler: validateIsEmailExist,
        *onSuccess(response) {
            const isExist = response?.data?.data?.exists
            const isAppExist = Boolean(response?.data?.data.platform === 'app' && isExist)
            if (isAppExist) {
                yield put(resetAuthErrors())
                yield put(saveAuthErrors({ email: { code: ErrorCodes.EMAIL_ALREADY_IN_USED_FOR_APP } }))
            } else {
                payload.onSuccess(Boolean(isExist))
            }
        },
    })
}

export function* watchVerifyEmailRequestFlow(): any {
    while (true) {
        const action = yield take(RegisterActions.VALIDATE_IS_EMAIL_EXISTED_REQUEST)
        yield fork(handleVerifyEmailRequest, action.payload)
    }
}

export function* handleSignupRequest(payload: SignUpPayloads) {
    yield handleRequest<SignUpPayloads, any>({
        stateKey: STATE_KEYS.SignUp,
        payload,
        ApiHandler: signUp,
        *onSuccess() {
            payload.onSuccess()
        },
        *onError(response) {
            if (payload.onError) {
                const errors = response?.validation_errors
                if (errors) {
                    yield put(resetAuthErrors())
                    yield put(saveAuthErrors(errors))
                } else {
                    payload.onError()
                }
            }
        },
    })
}

export function* watchSignupRequestFlow(): any {
    while (true) {
        const action = yield take(RegisterActions.SIGN_UP)
        yield fork(handleSignupRequest, action.payload)
    }
}

export function* handleSendInviteRequest(payload: SendInvitePayloads) {
    yield handleRequest<SendInvitePayloads, any>({
        stateKey: STATE_KEYS.SendInvite,
        payload,
        ApiHandler: sendInvite,
    })
}

export function* watchSendInviteRequestFlow(): any {
    while (true) {
        const action = yield take(RegisterActions.SEND_INVITE)
        yield fork(handleSendInviteRequest, action.payload)
    }
}

export function* handleSignDetailsRequest(payload: SignUpDetailsPayloads) {
    yield handleRequest<SignUpDetailsPayloads, any>({
        stateKey: STATE_KEYS.SignUpDetails,
        payload,
        ApiHandler: signUpDetails,
        *onSuccess() {
            if (payload.onSuccess) {
                payload.onSuccess()
            }
        },
        *onError() {
            if (payload.onError) {
                payload.onError()
            }
        },
    })
}

export function* watchSignDetailsRequestFlow(): any {
    while (true) {
        const action = yield take(RegisterActions.SIGN_UP_DETAILS)
        yield fork(handleSignDetailsRequest, action.payload)
    }
}

export function* handleInviteTeamMembersRequest(payload: InviteTeamMembersPayloads) {
    yield handleRequest<InviteTeamMembersPayloads, any>({
        stateKey: STATE_KEYS.InviteTeamMember,
        payload,
        ApiHandler: inviteTeamMembers,
        *onSuccess() {
            if (payload.onSuccess) {
                payload.onSuccess()
            }
        },
        *onError(response) {
            if (payload.onError) {
                const errors = response?.validation_errors
                if (errors) {
                    yield put(resetAuthErrors())
                    yield put(saveAuthErrors(errors))
                } else {
                    payload.onError()
                }
            }
        },
    })
}

export function* watchInviteTeamMembersRequestFlow(): any {
    while (true) {
        const action = yield take(RegisterActions.MASS_INVITE)
        yield fork(handleInviteTeamMembersRequest, action.payload)
    }
}
